import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CART_DELIVERY_TYPES } from '../../../../cart';

@Component({
  standalone: false,
  selector: 'gift-delivery-type-selector',
  templateUrl: './gift-delivery-type-selector.component.html',
  styleUrls: ['./gift-delivery-type-selector.component.scss']
})
export class GiftDeliveryTypeSelectorComponent implements OnInit {
  @Input() price: number;
  @Input() currency: string;
  @Input() type: string;
  @Input() pickupPointsCount: number;

  @Output() onDataChanged = new EventEmitter<string>();
  @Output() onShowOutletsMap = new EventEmitter<void>();

  public CART_DELIVERY_TYPES = CART_DELIVERY_TYPES;

  constructor() {
  }

  ngOnInit() {
  }

}
